// MIME Types of the files commonly used by the application
export default {
  PDF: "application/pdf",
  ZIP: "application/x-zip",
};
